/* TODO: https://codesandbox.io/s/xkkyw83vb?from-embed
  && https://github.com/apollographql/react-apollo-error-template/blob/master/src/graphql/link.js
*/
import React from 'react'
import gql from "graphql-tag";
import { Query } from "react-apollo";
import { Text } from 'grommet'

export const DISPLAY_NAME_QUERY =gql`
    query user {
        user(id: 6) { displayName }
    }
`

export const DisplayName = (props) => { 
    
    const color = props.color || 'medium' 
    const size = props.size || 'medium' 
    const weight = props.weight || 'medium'
    
    return(
        <Query query={DISPLAY_NAME_QUERY}>
        {({ loading, error, data }) => {
            if (error) {
                console.log(error.message)
                return <p>Error!</p>
            }
            if (loading || !data) return <p>Loading...</p>
            return <Text 
                        size={size} 
                        color={color}
                        weight={weight}
                    >{data.DisplayName}</Text>
        }}
        </Query>
    )
}